import React from "react";
import { Link } from "react-router-dom";
import TwitterIcon from "@mui/icons-material/Twitter";
import RedditIcon from "@mui/icons-material/Reddit";
import GitHubIcon from "@mui/icons-material/GitHub";
import LanguageIcon from "@mui/icons-material/Language";
import VerticalAlignTopOutlinedIcon from "@mui/icons-material/VerticalAlignTopOutlined";
import logo from "./scan-logo.png";

const scroll = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
};

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="term-footer">
      {/* Top action bar */}
      <div className="term-footer-actions">
        <div className="term-footer-socials">
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <TwitterIcon sx={{ fontSize: 16 }} />
          </a>
          <a href="https://reddit.com" target="_blank" rel="noopener noreferrer" aria-label="Reddit">
            <RedditIcon sx={{ fontSize: 16 }} />
          </a>
          <a href="https://github.com/MegaHoot/pecunovus" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <GitHubIcon sx={{ fontSize: 16 }} />
          </a>
          <a href="https://www.pecunovus.com" target="_blank" rel="noopener noreferrer" aria-label="Website">
            <LanguageIcon sx={{ fontSize: 16 }} />
          </a>
        </div>
        <button className="term-back-to-top" onClick={scroll}>
          <VerticalAlignTopOutlinedIcon sx={{ fontSize: 14 }} />
          <span>BACK TO TOP</span>
        </button>
      </div>

      <div className="term-footer-divider" />

      {/* Main columns */}
      <div className="term-footer-main">
        <div className="term-footer-brand">
          <div className="term-footer-brand-row">
            <img src={logo} alt="Pecu Novus" className="term-footer-logo" />
            <div>
              <div className="term-footer-brand-name">POWERED BY PECU NOVUS</div>
              <div className="term-footer-brand-sub">CARBON NEUTRAL · DECENTRALIZED</div>
            </div>
          </div>
          <p className="term-footer-desc">
            Pecu Novus is a carbon-neutral decentralized blockchain ecosystem focused on scalability,
            transparency, and secure smart contract execution.
          </p>
        </div>

        <div className="term-footer-col">
          <h4>▸ COMPANY</h4>
          <a href="https://www.pecunovus.com/about-pecu-novus/" target="_blank" rel="noreferrer">About Us</a>
          <a href="https://www.pecunovus.com/contact/" target="_blank" rel="noreferrer">Contact</a>
          <a href="https://www.pecunovus.com/pecu-novus-blog/" target="_blank" rel="noreferrer">Blog</a>
          <a href="https://www.pecunovus.com/pecu-novus-branding/" target="_blank" rel="noreferrer">Brand Assets</a>
        </div>

        <div className="term-footer-col">
          <h4>▸ PRODUCTS & SERVICES</h4>
          <Link to="/">Pecu Explorer</Link>
          <a href="https://docs.pecunovus.com/info/pecu-novus-developer-documentation/" target="_blank" rel="noreferrer">Pecu API</a>
          <a href="https://www.pecunovus.com/get-your-wallet/" target="_blank" rel="noreferrer">Pecu Wallet</a>
          <a href="https://github.com/MegaHoot/pecunovus" target="_blank" rel="noreferrer">Developer Tools</a>
        </div>

        <div className="term-footer-col">
          <h4>▸ EXPLORE</h4>
          <Link to="/allBlock">View Blocks</Link>
          <a>View Transactions</a>
          <a>Top Accounts</a>
          <a href="https://www.pecunovus.com/validators/" target="_blank" rel="noreferrer">Validators</a>
        </div>
      </div>

      {/* Status banner */}
      <div className="term-footer-status">
        <div className="term-footer-carbon">
          <span className="term-dot" style={{ background: "var(--term-green)" }} />
          A CARBON NEUTRAL BLOCKCHAIN NETWORK
        </div>
        <div className="term-footer-status-right">
          <span className="term-dot" />
          ALL SYSTEMS OPERATIONAL
        </div>
      </div>

      {/* Bottom legal */}
      <div className="term-footer-bottom">
        <div>© {year} PECU NOVUS · ALL RIGHTS RESERVED</div>
        <div className="term-footer-legal">
          <a href="https://www.pecunovus.com/privacy/" target="_blank" rel="noreferrer">PRIVACY</a>
          <span>·</span>
          <a href="https://www.pecunovus.com/legal/" target="_blank" rel="noreferrer">DISCLAIMER</a>
          <span>·</span>
          <a href="https://www.pecunovus.com/terms/" target="_blank" rel="noreferrer">TERMS</a>
          <span>·</span>
          <a href="https://www.pecunovus.com" target="_blank" rel="noreferrer">PECUNOVUS.COM</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;